import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, useStore } from 'react-redux';
import { CampaignBuilderHeader } from './header';
import { getIsDraft, getIsNewCampaign } from '../../store';
import { closeCampaign } from './close-campaign';
import { useNavigate } from '../../../../../infra/routing';
import { useSession } from '../../../../../infra/session';
import { useProgressIndicator } from './use-progress';
import { t } from '../../../../../infra/i18n';
export var CampaignBuilderHeaderContainer = function () {
    var store = useStore();
    var navigate = useNavigate();
    var session = useSession().data;
    var steps = useProgressIndicator().steps;
    var isDraft = useSelector(getIsDraft);
    var isNewCampaign = useSelector(getIsNewCampaign);
    var pageName;
    if (isNewCampaign) {
        pageName = t('engage:pages.create_campaign');
    }
    else if (isDraft) {
        pageName = t('engage:pages.edit_campaign');
    }
    else {
        pageName = t('engage:pages.campaign_details');
    }
    var handleCloseCampaign = function () {
        closeCampaign({
            store: store,
            navigate: navigate,
            session: session,
        });
    };
    return (_jsx(CampaignBuilderHeader, { showSteps: isNewCampaign || isDraft, pageName: pageName, onCloseCampaign: handleCloseCampaign, steps: steps }));
};
